const uniqueItems = (itens) => [
  ...new Map(itens?.map((item) => [item?.itemid, item]))?.values(),
];

export default uniqueItems;
